export default __webpack_public_path__ + "static/media/13-bm.fd64bc59.webp";